import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function SuccessPanel() {
  const navigate = useNavigate();
  useEffect(() => {
    const id = setTimeout(() => navigate("/login"), 3000);
    return () => clearTimeout(id);
  }, [navigate]);
  return (
    <div className="space-y-2 text-center" aria-live="polite">
      <h2 className="font-serif text-xl text-maroon-700">Password updated</h2>
      <p className="text-sm text-ink-500">Redirecting to sign in…</p>
    </div>
  );
}
